import ActionTypes from '../constants';

const initialState = {
    policeReports: {},
    policeReport: {},
    policeReportId: {},
    // loading: false,
};

const policeReportReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETPOLICESUCCESS:
            return {
                ...state,
                policeReports: action.payload,
            }
        case ActionTypes.GETPOLICEBYIDSUCCESS:
            return {
                ...state,
                policeReport: action.payload,
            }
        case ActionTypes.SAVEPOLICEREPORTSUCCESS:
            return {
                ...state,
                policeReportId: action.payload,
            }
        default:
            return state;
    }
}

export default policeReportReducer;